import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { SessionDataService } from 'inova-front-core/session';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private router: Router,private sessionService:SessionDataService) { }

    canActivate() {
        if (this.sessionService.isLoggedIn()) {
            return true;
        }
        this.sessionService.localLogout(true);
        return false;
    }
}
